import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadFormCRM from '../../../../components/LeadForm/LeadFormCRM';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';

function AziziVeniceSnapchat({
    language
}) {
    const clientId = process.env.REACT_APP_CLIENTID8;
    const clientMail = process.env.REACT_APP_CLIENTMAIL8;

    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const images = [
        "/assets/images/projects/azizi-venice/1.webp",
        "/assets/images/projects/azizi-venice/2.webp",
        "/assets/images/projects/azizi-venice/3.webp",
        "/assets/images/projects/azizi-venice/4.webp",
        "/assets/images/projects/azizi-venice/5.webp",
        "/assets/images/projects/azizi-venice/6.webp"
    ];

    return (
        <>
            <div>
                <NoiseBackground />
                {/* LANGUAGE */}
                <LanguageNavigate
                    redirect={language === "ar"
                        ? "/projects/azizi/venice/en-s"
                        : "/projects/azizi/venice/ar-s"
                    }
                />
                {/* LIMITED TIME OFFER */}
                <div className="padding-container my-5 py-5">
                    <Countdown />
                </div>

                <Height15 />

                {/* HEADING */}
                <div className="padding-container text-center my-5 py-5">
                    {language === "ar"
                        ? (
                            <h1 className="text-center px-2 my-1 text-xl">
                                دفعة مقدمة فقط
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "68,000 درهم"
                                            : (userInfo?.countryCode === "FR" || userInfo?.countryCode === "fr")
                                                ? "€18,000"
                                                : "$18,000"
                                    }
                                </span>
                                فقط!
                            </h1>
                        ) : (
                            <h1 className="text-center px-2 my-1 text-xl">
                                Down payment of just
                                <span className="text-2xl bounce-text secondary-text" id="price">
                                    {
                                        (userInfo?.countryCode === "AE" || userInfo?.countryCode === "ae")
                                            ? "AED 68,000"
                                            : (userInfo?.countryCode === "FR" || userInfo?.countryCode === "fr")
                                                ? "€18,000"
                                                : "$18,000"
                                    }
                                </span>
                                only!
                            </h1>
                        )
                    }
                </div>
            </div>
            {/* IMAGES */}
            <ImageSlider images={images} />
            <div className="p-5 my-5">
                {/* LEAD FORM */}
                <LeadFormCRM
                    developer="Azizi"
                    project="Venice"
                    leadType="Apartment"
                    leadSource={"Snapchat"}
                    language={currentLang?.name}
                    // client={true}
                    // clientId={clientId}
                    // clientEmail={clientMail}
                    enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms", "Retail"]}
                    client={false}
                />
            </div>
            <Footer />
        </>
    );
}

export default AziziVeniceSnapchat;
